require('./searchMenuService');
require('../../schedule/scheduleService');

angular.module('app.mainFrame.searchMenu.searchMenuController', [
  'app.mainFrame.searchMenu.searchMenuService',
  'app.schedule.scheduleService'
])
  .controller('app.mainFrame.searchMenu.searchMenuController', [
    '$scope',
    'app.mainFrame.searchMenu.searchMenuService',
    function ($scope, searchMenu) {
      "use strict";
      
      $scope.searchMenu = searchMenu;

      $scope.onSearchSelected = function () {
        searchMenu.isExpanded = false;
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/searchMenu/searchMenuController.js